import dom from '../../utils/dom';
import { loadModal } from '../../AsyncLoader';
import PaymentPlanService from './PaymentPlanService';
import ContentStorage, { ComponentKeys } from '../../tnew/content/ContentStorage';
import ModalUtils from "../../tnew/ui/Modal/ModalUtils";

const { formButtonHandler } = window.tnew.handlers;


function getModalProperties() {
  const key = ComponentKeys.PAYMENT_PLANS;

  return {
    title: ContentStorage.get(key, 'PaymentPlanSummarySectionSubhead'),
    labelBtnAccept: ContentStorage.get(key, 'CloseButtonLabel'),
  };
}


export default function initAppliedPaymentPlan() {
  const $el = dom.find('.tn-cart-applied-payment-plan');

  const $details = dom.findFrom($el, '.tn-cart-applied-payment-plan__details');
  const $btnViewDetails = dom.findFrom($el, '.tn-cart-applied-payment-plan__btn-view-details');
  const $btnRemove = dom.findFrom($el, '.tn-cart-applied-payment-plan__btn-remove');

  dom.remove($details);
  dom.unhide($details);

  $btnViewDetails.addEventListener('click', async () => {
    const Modal = await loadModal();

    const { title, labelBtnAccept } = getModalProperties();
    
    const $closeBtn = ModalUtils.makePrimaryButton(labelBtnAccept)[0];
    $closeBtn.setAttribute('data-dismiss', 'modal');

    Modal.open({
      title,
      bodyContents: $details,
      closeButtonInHeader: true,
      footerContents: [$closeBtn]
    });
  });


  $btnRemove.addEventListener('click', () => {
    formButtonHandler.applyBusyStyling($btnRemove);
    PaymentPlanService.removePaymentPlan();
  });
}
